function convertToCurrency(str) {
  function numberWithCommas(x) {
    return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function trimFirstTwoSymbols(x) {
    return x && x.substring(0, 2);
  }
  if (!str) return undefined;
  const [beforeDots, afterDots = '00'] = str.toString().split('.');
  return ` $${numberWithCommas(beforeDots || 0)}.${trimFirstTwoSymbols(`${afterDots}00`)} `;
}

/**
 * convertToCurrency returns undefined for 0/''/null and pads its result with
 * spaces, so callers nearly always want this instead.
 */
export function formatCurrency(amount) {
  // Round to the cent first. convertToCurrency cuts the string at two decimals, so float
  // leftovers like 2400 - 2189.98 = 210.01999... would otherwise read as $210.01.
  const rounded = Math.round((Number(amount) || 0) * 100) / 100;
  return (convertToCurrency(rounded) || '$0.00').trim();
}

/**
 * Rounded, comma-grouped dollars with no cents - e.g. 5000 -> "$5,000".
 * Used where copy reads as an approval headline rather than an exact amount.
 */
export function formatWholeDollars(amount) {
  return `$${Math.round(Number(amount) || 0).toLocaleString('en-US')}`;
}

/**
 * Exact amount, but drops ".00" on whole dollars - 5000 -> "$5,000", 3870.01 -> "$3,870.01".
 * For running copy where a trailing ".00" reads as noise but real cents still matter.
 */
export function formatCurrencyCompact(amount) {
  const cents = Math.round((Number(amount) || 0) * 100);
  return cents % 100 === 0 ? formatWholeDollars(cents / 100) : formatCurrency(cents / 100);
}

export default convertToCurrency;
